import { cn } from "@/lib/utils";
import { NodeCard, WORKLOAD_NAME, SERVICE_NODES } from "./internals";
import type { GraphNode } from "./internals";

const MAP_GRAPH_NODES: GraphNode[] = [
  {
    id: "api",
    ...SERVICE_NODES.api,
    className: "md:left-[4%] md:top-[42%] md:w-[29%]",
  },
  {
    id: "lambda",
    ...SERVICE_NODES.lambda,
    className: "md:left-[35%] md:top-[42%] md:w-[29%]",
  },
  {
    id: "dynamo",
    ...SERVICE_NODES.dynamo,
    tone: "accent" as const,
    className: "md:left-[67%] md:top-[19%] md:w-[29%]",
  },
  {
    id: "s3",
    ...SERVICE_NODES.s3,
    className: "md:left-[67%] md:top-[58%] md:w-[29%]",
  },
];

export function MapVisual() {
  return (
    <div className="relative min-h-[220px] rounded-lg border border-dashed border-primary/45 bg-primary-tint/30 p-4 sm:min-h-[260px] sm:p-5 md:min-h-[300px]">
      <div className="absolute -top-3 left-4 rounded-sm border border-primary/30 bg-surface px-2 py-1 font-mono text-[12px] font-semibold uppercase tracking-[0.08em] text-primary sm:left-6">
        Workload <span className="ml-1 normal-case tracking-normal text-foreground-muted">{WORKLOAD_NAME}</span>
      </div>
      <svg
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 z-0 hidden h-full w-full md:block"
        viewBox="0 0 640 300"
        preserveAspectRatio="none"
      >
        <defs>
          <marker
            id="map-arrow"
            markerHeight="8"
            markerWidth="8"
            orient="auto"
            refX="7"
            refY="4"
            viewBox="0 0 8 8"
          >
            <path d="M0,0 L8,4 L0,8" fill="none" stroke="currentColor" strokeWidth="1.4" />
          </marker>
        </defs>
        <g className="text-foreground-muted" fill="none" stroke="currentColor" strokeWidth="1.25">
          <path d="M211 151H224" markerEnd="url(#map-arrow)" />
          <path d="M410 151H430C448 151 458 136 458 118V96C458 78 470 66 488 66H512" strokeDasharray="4 4" />
          <path d="M410 151H430C448 151 458 166 458 184V204C458 222 470 234 488 234H512" strokeDasharray="4 4" />
          <circle cx="434" cy="142" r="4" fill="var(--background)" />
          <circle cx="434" cy="160" r="4" fill="var(--background)" />
          <path d="M434 146V156" />
        </g>
      </svg>
      <div className="grid gap-3 md:block">
        {MAP_GRAPH_NODES.map((node) => (
          <NodeCard
            key={node.id}
            icon={node.icon}
            title={node.title}
            detail={node.detail}
            {...(node.tone !== undefined && { tone: node.tone })}
            className={cn("md:absolute md:z-10", node.className)}
          />
        ))}
      </div>
    </div>
  );
}
